import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail, ADMIN_TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=unauth, object=auth
  const [error, setError] = useState("");

  const loadMe = useCallback(async () => {
    // Only attempt /auth/me if we have an admin token (avoids 401/403 spam in console)
    if (!localStorage.getItem(ADMIN_TOKEN_KEY)) {
      setUser(false);
      return;
    }
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      // Token invalid or expired
      localStorage.removeItem(ADMIN_TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem(ADMIN_TOKEN_KEY, data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      // Mejor diagnóstico para el usuario
      let msg;
      if (e.response?.data?.detail) {
        msg = formatApiErrorDetail(e.response.data.detail);
      } else if (e.response?.status === 401) {
        msg = "Email o contraseña incorrectos.";
      } else if (e.message === "Network Error" || !e.response) {
        msg = "No se pudo conectar con el servidor. Verifica tu conexión o intenta nuevamente.";
      } else {
        msg = e.message || "Ocurrió un error. Intenta nuevamente.";
      }
      setError(msg);
      return { ok: false, error: msg };
    }
  };

  const logout = async () => {
    try {
      await http.post("/auth/logout");
    } catch {}
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
